import type { FilterOption, InvoiceItemFilters } from '../../model/InvoiceItemFilters';
import type { AdproductsZuoraBillingInvoiceDto } from '@zg-rentals/ts-adproducts-client';

const mapValues = (set: Set<string>): Array<FilterOption> =>
  Array.from(set)
    .sort()
    .map((item) => ({
      label: item,
      isChecked: false,
    }));

export const calculateFilters = (invoice: AdproductsZuoraBillingInvoiceDto) => {
  if (!invoice) return {};
  const { zuoraInvoiceItems: invoiceItems } = invoice;
  if (!invoiceItems) return {};
  const filters: InvoiceItemFilters = {};
  const propertySet = new Set<string>();
  const productSet = new Set<string>();
  const citySet = new Set<string>();
  const stateSet = new Set<string>();
  invoiceItems.forEach((item) => {
    if (item.propertyName) propertySet.add(item.propertyName);
    if (item.chargeName) productSet.add(item.chargeName);
    if (item.city) citySet.add(item.city);
    if (item.state) stateSet.add(item.state);
  });
  if (propertySet.size > 1) {
    filters.propertyName = {
      title: 'Property',
      options: mapValues(propertySet),
    };
  }
  if (productSet.size > 1) {
    filters.chargeName = {
      title: 'Charge Item',
      options: mapValues(productSet),
    };
  }
  if (citySet.size > 1) {
    filters.city = {
      title: 'City',
      options: mapValues(citySet),
    };
  }
  if (stateSet.size > 1) {
    filters.state = {
      title: 'State',
      options: mapValues(stateSet),
    };
  }
  return filters;
};
